import React, { useEffect, useState } from 'react'
import RecurringDepositsPage from '../../../RecurringDeposites'
import { useSelector } from 'react-redux';
import { recurringDeposite } from '../../../../../api/commonApis';

const RecurringDeposites = ({onClickTabChange = () => { }}) => {
  const { reportDetails, selectedAccountId } = useSelector(({ reportDetails }) => reportDetails);
  const [recurring, setRecurring] = useState([]);

  useEffect(() => {

      const fetchData = async () => {
        try {
          let aggregate = selectedAccountId !== 'all'? false : true;
          let account_id = selectedAccountId !== 'all'? selectedAccountId : reportDetails?.report?.reportId;
          const response = await recurringDeposite(account_id, aggregate);
  
          // console.log("Abdul API CALL INTRABANK", response);
  
          if(Object.keys(response).length > 0){
            setRecurring(response)
          } else{
            setRecurring([])
          }
  
        } catch (error) {
  
          console.log("ERROR", error);
        }
      }
  
      if (selectedAccountId) fetchData();
    }, [selectedAccountId]);
  return (
    <RecurringDepositsPage recurring={recurring} onClickTabChange={onClickTabChange} />
  )
}

export default RecurringDeposites